export default "__VITE_ASSET__DV_zV$EB__"